const contextualActions = [
    "userPicklist.AddToReference",
    "referencedfields.ClearFields",
    "referencedfields.SwitchToManual",
    "referencedfields.SwitchToReferenced",
    "referencedfields.SelectFromReference",
    "modalInstanceUnit.Open",
    "modalInstanceUnit.Close",
] as const;

export type ContextualActionNames = (typeof contextualActions)[number];

export function isValidContextualActionName(value: string): value is ContextualActionNames {
    return contextualActions.some(() => value);
}

export function isContextualActionName(handlerName: string): boolean {
    return handlerName.includes(".");
}
